// Back from learning is a fresh server decision, not a local navigation toggle.
export async function resumeLessonRoute({ lesson, locate, request, isCurrent }) {
  const guard = () => {
    if (!isCurrent()) throw new Error('The lesson changed. Check the current lesson before continuing.');
  };
  const checkIdentity = data => {
    if (data?.lesson_id !== lesson.id || data?.started_at !== lesson.started_at)
      throw new Error('The route belongs to a different lesson.');
  };
  guard();
  const location = await locate();
  guard();
  let data = await request('return-check', location);
  guard();
  checkIdentity(data);
  if (!['TEACHING', 'RETURNING'].includes(data.status)
      || !Number.isFinite(Date.parse(data.latest_safe_departure_iso)))
    throw new Error('Return timing could not be confirmed.');
  const returning = data.status === 'RETURNING';
  if (!returning) {
    // A slow return check must not recycle an ageing device fix.
    const freshLocation = await locate();
    guard();
    data = await request('recover-route', freshLocation);
    guard();
    checkIdentity(data);
  }
  const plan = data.route_plan;
  const saved = data.saved_plan;
  if (plan?.route_state !== 'READY' || !plan.route_geometry
      || !saved?.navigation_recipe || !saved.recovery_id
      || saved.recovery_id !== plan.recovery_id
      || (returning && (!saved.return_mode || !plan.return_mode || saved.challenge_sequence?.length !== 0)))
    throw new Error('Updated guidance could not be confirmed.');
  return data;
}
